<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateLocation"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Create Company</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Company Name</label>
              <input
                v-model="info.Name"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full capitalize"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Country</label>
              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="info.Country"
                :default-first-item="true"
                placeholder="Enter a country"
              >
                <el-option
                  v-for="country in countries"
                  :key="country.Name"
                  :label="country.Name"
                  :value="country.Name"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import { africanCountries } from "@/utils/utilsData";
export default {
  name: "CompanySetupCreateLocation",
  props: ["showCreateLocation"],
  components: { Loader },
  data() {
    return {
      saved_departments: [],
      country: null,
      countries: [],
      info: {
        Name: null,
        Country: null,
        Town: null,
      },

      create_error: null,
      loading: false,
    };
  },
  created() {
    this.countries = africanCountries;
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },

    async fetchCountries(queryString, callback) {
      // fetch locations
      // based on the user input and call the callback function
      // with the resulting suggestions
      if (queryString) {
        this.country = africanCountries.filter((country) =>
          country.Name.toLowerCase().includes(queryString.toLowerCase())
        );
        //console.log(this.country)
        if (queryString && !this.country.length) {
          callback([{ Name: "No results found", Country: "No results found" }]);
          return;
        }
        callback(this.country);
      } else {
        callback(africanCountries);
      }
    },

    setCountryName(country) {
      this.info.Country = country.Name;
    },

    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .post(
          `${this.getOrganization}/setup/location/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit("closeOnSuccess");
              this.info = {
                Name: null,
                Country: null,
                Town: null,
              };
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
